import { Controller } from "@hotwired/stimulus"

// Le due modalità manuali del timesheet: ore dirette oppure inizio/fine.
//
// I campi dell'altra modalità restano nel DOM ma vengono svuotati: è così che
// il modello capisce quale modalità è stata usata, senza un campo nascosto in
// più da tenere allineato.
export default class extends Controller {
  static targets = ["modeRadio", "hoursFields", "intervalFields", "startTime", "endTime", "preview"]
  static values = { mode: String }

  connect() {
    this.apply(this.modeValue || "hours")
    this.updatePreview()
    this.startTimeTarget?.addEventListener("input", () => this.updatePreview())
    this.endTimeTarget?.addEventListener("input", () => this.updatePreview())
  }

  switchMode(event) {
    this.apply(event.target.value)
  }

  apply(mode) {
    const interval = mode === "interval"
    this.hoursFieldsTarget.classList.toggle("hidden", interval)
    this.intervalFieldsTarget.classList.toggle("hidden", !interval)

    // Svuotare l'altra modalità evita righe ambigue: un'ora scritta a mano e
    // un intervallo salvato prima direbbero due cose diverse.
    if (interval) {
      this.hoursFieldsTarget.querySelector("input").value = ""
    } else {
      this.startTimeTarget.value = ""
      this.endTimeTarget.value = ""
    }
    this.updatePreview()
  }

  // Anteprima della durata mentre si digita: sapere subito che sono 3h 30m
  // evita di scoprire l'errore dopo aver salvato.
  updatePreview() {
    if (!this.hasPreviewTarget) return

    const start = this.startTimeTarget.value
    const end = this.endTimeTarget.value
    if (!start || !end) {
      this.previewTarget.textContent = ""
      return
    }

    let minutes = this.#minutes(end) - this.#minutes(start)
    if (minutes <= 0) minutes += 24 * 60 // turno che passa la mezzanotte

    const h = Math.floor(minutes / 60)
    const m = minutes % 60
    this.previewTarget.textContent = m === 0 ? `${h}h` : `${h}h ${m}m`
  }

  #minutes(value) {
    const [h, m] = value.split(":")
    return Number(h) * 60 + Number(m)
  }
}
